/* Exotic Snack Guys add-ons: header search + menu drawer, quick add (+ size sheet), size badges,
   free-shipping bar, upsell, bundle add-ons, Build-a-Box, product description "See more". */
(function () {
  'use strict';
  if (window.__esgLoaded) return;
  window.__esgLoaded = true;

  var cfg = window.ESG || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var docEl = document.documentElement;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || (window.theme && theme.money_format) || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function withDelims(num, dec, thou, sep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }
  function debounce(fn, ms) {
    var t;
    return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    docEl.classList.add('esg-lock');
    var focusable = el.querySelector('[data-esg-close-btn], a[href], button:not([disabled]), input');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.esg-drawer.is-open')) docEl.classList.remove('esg-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    $all('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-esg-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.esg-drawer')); return; }
    var menuBtn = e.target.closest('[data-esg-menu-open]');
    if (menuBtn) {
      e.preventDefault();
      menuBtn.setAttribute('aria-expanded', 'true');
      openDrawer(document.getElementById('esg-menu'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $all('.esg-drawer.is-open').forEach(closeDrawer); return; }
    // Keep Tab inside an open drawer (it is a modal dialog).
    if (e.key !== 'Tab') return;
    var open = $('.esg-drawer.is-open .esg-drawer__panel');
    if (!open) return;
    var items = $all('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', open)
      .filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (!open.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- cart ----------
     The slide-out cart itself lives in snippets/body-end-tag.liquid + assets/cart-drawer.js
     (window.esgCartDrawer). This file only feeds it: header icon, quick add, bundle add, upsell. */
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  function sideCart() { return window.esgCartDrawer || null; }

  function updateCounts(count) {
    if (count === null || count === undefined || count === '') return;
    $all('[data-esg-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
    });
    $all('[data-esg-cart-open]').forEach(function (a) {
      a.setAttribute('aria-label', ((cfg.strings && cfg.strings.cart) || 'Cart') + ' (' + count + ')');
    });
  }
  function fetchCount() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCounts(c.item_count); })
      .catch(function () {});
  }
  // Keep the header bubble in step whenever the side cart re-renders (qty changes, removals, adds).
  function watchSideCart() {
    var box = document.getElementById('esg-cart-drawer');
    if (!box || box.hasAttribute('data-esg-watched') || !('MutationObserver' in window)) return;
    box.setAttribute('data-esg-watched', '');
    new MutationObserver(function () {
      var inner = box.querySelector('[data-esg-cd-inner]');
      if (inner) updateCounts(inner.getAttribute('data-item-count'));
    }).observe(box, { childList: true, subtree: true });
  }

  function closeQuickView(form) {
    var modal = form && form.closest('#quick-buy-modal');
    var x = modal && modal.querySelector('[data-modal-close]');
    if (x) { x.click(); return 350; }
    return 0;
  }

  function afterAdd(form) {
    if (onCartPage) { location.reload(); return Promise.resolve(); }
    var sc = sideCart();
    if (!sc) return fetchCount();
    var delay = closeQuickView(form);
    return sc.refresh().catch(function () {}).then(function () {
      // ESG Oct 29: show the small "Added to cart" notice instead of sliding the cart open (see cart-drawer.js).
      setTimeout(function () { if (sc.toast) sc.toast(); else sc.open(); }, delay);
      return fetchCount();
    });
  }

  function addItems(items) {
    return postJSON(root + 'cart/add.js', { items: items });
  }

  // Short inline message next to whatever was tapped (no browser alerts).
  function flashError(anchor, msg) {
    if (!anchor) return;
    var host = anchor.closest('form, .esg-upsell, [data-esg-bab]') || anchor.parentNode;
    var note = host.querySelector('.esg-err');
    if (!note) {
      note = document.createElement('p');
      note.className = 'esg-err';
      note.setAttribute('role', 'alert');
      host.appendChild(note);
    }
    note.textContent = msg || 'Something went wrong. Please try again.';
    clearTimeout(note._t);
    note._t = setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 6000);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-esg-cart-open]');
    if (opener) {
      if (onCartPage || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var sc = sideCart();
      if (!sc) return; // plain link to /cart
      e.preventDefault();
      sc.open();
      sc.refresh().catch(function () {});
      return;
    }

    var addBtn = e.target.closest('[data-esg-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var label = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.textContent = (cfg.strings && cfg.strings.adding) || 'Adding…';
      addItems([{ id: Number(addBtn.getAttribute('data-esg-add')), quantity: 1 }])
        .then(function () { return afterAdd(addBtn.closest('form')); })
        .catch(function (err) { flashError(addBtn, err.message); })
        .then(function () { addBtn.disabled = false; addBtn.innerHTML = label; });
    }
  });

  /* ---------- add-to-cart forms ----------
     The theme keeps doing normal product-page adds (the side cart opens on its own).
     This only takes over for: card quick add, and product pages where bundle add-ons are ticked
     (so the box and its add-ons go into the cart in one request). */
  function formToItem(form) {
    var fd = new FormData(form);
    var item = { quantity: 1, properties: {} };
    fd.forEach(function (value, key) {
      if (key === 'id') item.id = Number(value);
      else if (key === 'quantity') item.quantity = Math.max(1, Number(value) || 1);
      else if (key === 'selling_plan' && value) item.selling_plan = Number(value);
      else {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && value !== '') item.properties[m[1]] = value;
      }
    });
    if (!Object.keys(item.properties).length) delete item.properties;
    return item;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var isQuickAdd = form.hasAttribute('data-esg-qa');
    var scope = form.closest('.product-area') || form;
    var extras = isQuickAdd ? [] : $all('[data-esg-bundle-item]:checked', scope);
    if (!isQuickAdd && !extras.length) return;

    var item = formToItem(form);
    if (!item.id) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.getAttribute('data-esg-busy') === '1') return;
    form.setAttribute('data-esg-busy', '1');

    // A subscription picked in the Seal Subscriptions widget sits inside the form, so formToItem() already has it.
    var items = [item];
    extras.forEach(function (cb) { items.push({ id: Number(cb.value), quantity: 1 }); });

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = (cfg.strings && cfg.strings.adding) || 'Adding…'; }
    var status = $('.product-status-message', form);
    if (status) status.textContent = '';

    addItems(items)
      .then(function () {
        extras.forEach(function (cb) { cb.checked = false; cb.dispatchEvent(new Event('change', { bubbles: true })); });
        if (btn) btn.setAttribute('data-esg-added', '1');
        return afterAdd(form);
      })
      .catch(function (err) {
        if (status) { status.textContent = err.message; }
        else { flashError(btn || form, err.message); }
      })
      .then(function () {
        // ESG Oct 29: show "Added ✓" on the button for a moment after a successful add.
        if (btn && btn.getAttribute('data-esg-added') === '1') {
          btn.removeAttribute('data-esg-added');
          btn.textContent = 'Added \u2713';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1400);
        } else if (btn) { btn.disabled = false; btn.innerHTML = original; }
        form.removeAttribute('data-esg-busy');
      });
  }, true);

  // The theme's phone sticky "Add to cart" submits the form through jQuery, which skips the listener
  // above. When add-ons are ticked, send a real submit instead so they go into the cart too.
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest && e.target.closest('.product-area__add-to-cart-xs button');
    if (!sticky) return;
    var area = sticky.closest('.product-area') || document;
    var form = $('.product-detail__form form.product-purchase-form', area);
    if (!form || !$all('[data-esg-bundle-item]:checked', area).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  /* ---------- quick add chips: keep button price label in sync ---------- */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('.esg-qa input[type="radio"]');
    if (!radio) return;
    var form = radio.closest('form');
    var priceEl = form && form.querySelector('[data-esg-qa-price]');
    if (priceEl && radio.getAttribute('data-price')) priceEl.textContent = radio.getAttribute('data-price');
  });

  /* ---------- quick add size sheet ----------
     Cards with qa_style 'compact' (snippets/esg-quick-add.liquid): "Choose" opens this sheet with the sizes
     from the card's <template>. Without JavaScript, "Choose" is a plain link to the product page. */
  var sheet = null;
  var sheetPanel = null;
  var sheetOpener = null;
  function sheetIsOpen() { return !!(sheet && sheet.classList.contains('is-open')); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); } }
  function openSheet(tpl, btn) {
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'esg-sheet';
      sheet.hidden = true;
      sheet.innerHTML = '<div class="esg-sheet__overlay" data-esg-sheet-close></div>' +
        '<div class="esg-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="esg-sheet-title" tabindex="-1"></div>';
      document.body.appendChild(sheet);
      sheetPanel = sheet.querySelector('.esg-sheet__panel');
    }
    sheetOpener = btn;
    sheetPanel.innerHTML = '';
    sheetPanel.appendChild(tpl.content.cloneNode(true));
    sheet.hidden = false;
    void sheet.offsetWidth; // start the slide-in from the closed position
    sheet.classList.add('is-open');
    docEl.classList.add('esg-lock', 'esg-sheet-open');
    btn.setAttribute('aria-expanded', 'true');
    var first = $('input:checked', sheetPanel) || $('input:not([disabled])', sheetPanel) || sheetPanel;
    setTimeout(function () { focusEl(first); }, 60);
  }
  function closeSheet(returnFocus) {
    if (!sheetIsOpen()) return;
    sheet.classList.remove('is-open');
    docEl.classList.remove('esg-sheet-open');
    if (!$('.esg-drawer.is-open')) docEl.classList.remove('esg-lock');
    setTimeout(function () { if (!sheetIsOpen()) { sheet.hidden = true; sheetPanel.innerHTML = ''; } }, 320);
    if (sheetOpener) {
      sheetOpener.setAttribute('aria-expanded', 'false');
      if (returnFocus) focusEl(sheetOpener);
    }
  }
  function sheetError(msg) {
    var el = sheetPanel && $('[data-esg-sheet-err]', sheetPanel);
    if (!el) return;
    el.textContent = msg || 'Something went wrong. Please try again.';
    el.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var chooser = e.target.closest('[data-esg-qa-choose]');
    if (chooser) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var wrap = chooser.closest('.esg-qa');
      var tpl = wrap && $('template[data-esg-qa-sheet]', wrap);
      if (!tpl || !('content' in tpl)) return; // plain link to the product page
      e.preventDefault();
      openSheet(tpl, chooser);
      return;
    }
    if (!sheetIsOpen()) return;
    if (e.target.closest('[data-esg-sheet-close]')) { e.preventDefault(); closeSheet(true); return; }
    var add = e.target.closest('[data-esg-sheet-add]');
    if (!add || add.disabled) return;
    e.preventDefault();
    var picked = $('input[name="esg-sheet-size"]:checked', sheetPanel);
    if (!picked) { sheetError('Choose a size first.'); return; }
    var err = $('[data-esg-sheet-err]', sheetPanel);
    if (err) err.hidden = true;
    var label = add.innerHTML;
    add.disabled = true;
    add.textContent = (cfg.strings && cfg.strings.adding) || 'Adding…';
    addItems([{ id: Number(picked.value), quantity: 1 }])
      .then(function () { closeSheet(false); return afterAdd(null); })
      .catch(function (er) { sheetError(er && er.message); })
      .then(function () { add.disabled = false; add.innerHTML = label; });
  });

  document.addEventListener('change', function (e) {
    if (!sheetIsOpen() || !sheetPanel.contains(e.target)) return;
    var price = $('[data-esg-sheet-price]', sheetPanel);
    if (price && e.target.getAttribute('data-price')) price.textContent = e.target.getAttribute('data-price');
    var err = $('[data-esg-sheet-err]', sheetPanel);
    if (err) err.hidden = true;
  });

  document.addEventListener('keydown', function (e) {
    // "Choose" is a link acting as a button: let Space open it too.
    var ch = (e.key === ' ' || e.key === 'Spacebar') && e.target.closest && e.target.closest('[data-esg-qa-choose]');
    if (ch) { e.preventDefault(); ch.click(); return; }
    if (!sheetIsOpen()) return;
    if (e.key === 'Escape') { closeSheet(true); return; }
    if (e.key !== 'Tab') return;
    // Keep Tab inside the sheet (it is a modal dialog). Only the picked size is a Tab stop.
    var items = $all('a[href], button:not([disabled]), input:not([disabled])', sheetPanel)
      .filter(function (el) {
        if (el.type === 'radio' && !el.checked) return false;
        return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!sheetPanel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- predictive search ---------- */
  function initSearch(form) {
    var input = $('input[name="q"]', form);
    var results = $('[data-esg-search-results]', form);
    if (!input || !results || form.hasAttribute('data-esg-ready')) return;
    form.setAttribute('data-esg-ready', '1');
    var active = -1;
    var lastQuery = '';

    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var html = '';
      if (collections.length) {
        html += '<p class="esg-search__group" role="presentation">Collections</p><ul class="esg-search__chips" role="none">';
        collections.slice(0, 4).forEach(function (c) {
          html += '<li role="none"><a role="option" aria-selected="false" class="esg-search__chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        });
        html += '</ul>';
      }
      if (products.length) {
        html += '<p class="esg-search__group" role="presentation">Products</p><ul class="esg-search__list" role="none">';
        products.forEach(function (p) {
          var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="esg-search__ph"></span>';
          var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
          html += '<li role="none"><a role="option" aria-selected="false" class="esg-search__item' + (p.available === false ? ' is-soldout' : '') + '" href="' + esc(p.url) + '">' + img +
            '<span class="esg-search__text"><span class="esg-search__title">' + esc(p.title) + '</span>' +
            '<span class="esg-search__price">' + esc(price) + (p.available === false ? ' · Sold out' : '') + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (!products.length && !collections.length) {
        html += '<p class="esg-search__empty" role="presentation">No matches for “' + esc(q) + '”.</p>';
      }
      html += '<button type="submit" role="option" aria-selected="false" class="esg-search__all">Search all for “' + esc(q) + '” →</button>';
      results.innerHTML = html;
      $all('[role="option"]', results).forEach(function (o, i) { o.id = 'esg-opt-' + i; o.tabIndex = -1; });
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { lastQuery = ''; close(); return; }
      lastQuery = q;
      var url = (cfg.predictiveUrl || root + 'search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (q === lastQuery) render(q, data); })
        .catch(close);
    }, 180);

    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (results.innerHTML && input.value.trim().length >= 2) { results.hidden = false; } });
    input.addEventListener('keydown', function (e) {
      var opts = $all('[role="option"]', results);
      if (results.hidden || !opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = e.key === 'ArrowDown' ? Math.min(active + 1, opts.length - 1) : Math.max(active - 1, 0);
        opts.forEach(function (o, i) {
          o.classList.toggle('is-active', i === active);
          o.setAttribute('aria-selected', i === active ? 'true' : 'false');
        });
        input.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1 && opts[active].tagName === 'A') {
        e.preventDefault();
        location.href = opts[active].href;
      } else if (e.key === 'Escape') {
        close();
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  /* ---------- product page: size buttons with price + Most Popular ---------- */
  function decorateSizes() {
    $all('script[data-esg-size-meta]').forEach(function (tag) {
      var meta;
      try { meta = JSON.parse(tag.textContent); } catch (err) { return; }
      var area = tag.closest('.product-area') || document;
      $all('.clickyboxes [data-value]', area).forEach(function (box) {
        if (box.getAttribute('data-esg-done')) return;
        var info = meta[box.getAttribute('data-value')];
        if (!info) return;
        box.setAttribute('data-esg-done', '1');
        box.classList.add('esg-sizebox');
        if (info.price) {
          var p = document.createElement('span');
          p.className = 'esg-sizebox__price';
          p.textContent = info.price;
          box.appendChild(p);
        }
        if (info.note) {
          var n = document.createElement('span');
          n.className = 'esg-sizebox__note';
          n.textContent = info.note;
          box.appendChild(n);
        }
        if (info.badge) {
          var b = document.createElement('span');
          b.className = 'esg-sizebox__badge';
          b.textContent = info.badge;
          box.appendChild(b);
          box.classList.add('is-popular');
        }
      });
      if ($('.clickyboxes', area)) area.classList.add('esg-has-sizeboxes');
    });
  }

  /* ---------- bundle block: live total ---------- */
  function initBundles() {
    $all('[data-esg-bundle]').forEach(function (box) {
      if (box.getAttribute('data-esg-ready')) return;
      box.setAttribute('data-esg-ready', '1');
      var countEl = $('[data-esg-bundle-count]', box);
      box.addEventListener('change', function () {
        var n = $all('[data-esg-bundle-item]:checked', box).length;
        $all('.esg-bundle__item', box).forEach(function (l) {
          var cb = $('input', l);
          l.classList.toggle('is-selected', !!(cb && cb.checked));
        });
        if (countEl) countEl.textContent = n ? n + ' added — they go in with this item when you tap Add to cart' : '';
      });
    });
  }

  /* ---------- Build-a-Box ---------- */
  function initBuildABox(sec) {
    if (sec.getAttribute('data-esg-ready')) return;
    sec.setAttribute('data-esg-ready', '1');
    var max = Number(sec.getAttribute('data-picks')) || 5;
    var variantId = Number(sec.getAttribute('data-variant')) || 0;
    var picks = {}; // id -> {qty, title, img}
    var slots = $('[data-bab-slots]', sec);
    var countEl = $all('[data-bab-count]', sec);
    var addBtn = $('[data-bab-add]', sec);
    var msg = $('[data-bab-msg]', sec);

    function total() { return Object.keys(picks).reduce(function (s, k) { return s + picks[k].qty; }, 0); }
    function render() {
      var n = total();
      countEl.forEach(function (el) { el.textContent = n; });
      sec.classList.toggle('is-full', n >= max);
      // slots
      if (slots) {
        var html = '';
        var list = [];
        Object.keys(picks).forEach(function (k) { for (var i = 0; i < picks[k].qty; i++) list.push(picks[k]); });
        for (var s = 0; s < max; s++) {
          var p = list[s];
          html += '<li class="esg-bab__slot' + (p ? ' is-filled' : '') + '">' +
            (p ? (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="44" height="44">' : '<span>' + esc(p.title.charAt(0)) + '</span>') : '<span>' + (s + 1) + '</span>') + '</li>';
        }
        slots.innerHTML = html;
      }
      $all('[data-bab-item]', sec).forEach(function (card) {
        var id = card.getAttribute('data-bab-item');
        var q = picks[id] ? picks[id].qty : 0;
        card.classList.toggle('is-picked', q > 0);
        var qEl = $('[data-bab-qty]', card);
        if (qEl) qEl.textContent = q;
        var plus = $('[data-bab-plus]', card);
        if (plus) plus.disabled = n >= max;
      });
      if (addBtn) addBtn.disabled = !(variantId && n === max);
      if (msg) {
        msg.textContent = n === max ? 'Your box is full — add it to your cart!' : 'Pick ' + (max - n) + ' more';
      }
    }

    sec.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-bab-plus]');
      var minus = e.target.closest('[data-bab-minus]');
      var tab = e.target.closest('[data-bab-tab]');
      if (tab) {
        var key = tab.getAttribute('data-bab-tab');
        $all('[data-bab-tab]', sec).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        $all('[data-bab-panel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-bab-panel') !== key; });
        return;
      }
      if (plus || minus) {
        var card = (plus || minus).closest('[data-bab-item]');
        var id = card.getAttribute('data-bab-item');
        if (plus) {
          if (total() >= max) return;
          if (!picks[id]) picks[id] = { qty: 0, title: card.getAttribute('data-title'), img: card.getAttribute('data-img') };
          picks[id].qty++;
        } else if (picks[id]) {
          picks[id].qty--;
          if (picks[id].qty <= 0) delete picks[id];
        }
        render();
        return;
      }
      if (e.target.closest('[data-bab-clear]')) { picks = {}; render(); return; }
      if (e.target.closest('[data-bab-add]')) {
        if (!variantId || total() !== max) return;
        var summary = Object.keys(picks).map(function (k) {
          return picks[k].title + (picks[k].qty > 1 ? ' ×' + picks[k].qty : '');
        }).join(', ');
        var props = {};
        props[sec.getAttribute('data-prop') || 'Snacks'] = summary;
        props._box_ref = Date.now().toString(36);
        var label = addBtn.innerHTML;
        var failed = '';
        addBtn.disabled = true;
        addBtn.textContent = (cfg.strings && cfg.strings.adding) || 'Adding…';
        addItems([{ id: variantId, quantity: 1, properties: props }])
          .then(function () { picks = {}; render(); return afterAdd(null); })
          .catch(function (err) { failed = (err && err.message) || 'Something went wrong. Please try again.'; })
          .then(function () {
            addBtn.innerHTML = label;
            render();
            if (failed && msg) msg.textContent = failed; // keep the error visible after re-render
          });
      }
    });
    render();
  }

  /* ---------- product description: See more ----------
     Product pages: a long description (tabs block, tab 1, or a description block) is cut to about 6 lines with a
     fade, and a "See more" button under it shows the rest ("See less" folds it again). Descriptions that are at
     most 3 lines longer than that stay whole, with no button. Without JavaScript the full text shows.
     Styles: assets/esg.css ("Product description: See more"). */
  var MORE_LINES = 6;
  var MORE_SLACK = 3;
  var MORE_SEL = '.product-detail__tab-container .cc-tabs__tab__panel[id^="product-tab-panel1_"], .product-detail__form__description';
  function moreLabel(open) {
    var s = cfg.strings || {};
    return open ? (s.seeLess || 'See less') : (s.seeMore || 'See more');
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function setMore(panel, open) {
    var btn = panel._esgMoreBtn;
    panel.setAttribute('data-esg-more', open ? 'open' : 'closed');
    panel.classList.toggle('is-clamped', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.firstChild.textContent = moreLabel(open);
  }
  function measureMore(panel) {
    var btn = panel._esgMoreBtn;
    if (!btn || panel.getAttribute('data-esg-more') === 'open') return;
    var lh = parseFloat(getComputedStyle(panel).lineHeight) || 24;
    var limit = Math.round(lh * MORE_LINES);
    panel.style.setProperty('--esg-more-h', limit + 'px');
    // scrollHeight is the full text height, also while it is cut off.
    var needs = panel.scrollHeight > limit + lh * MORE_SLACK;
    panel.classList.toggle('is-clamped', needs);
    btn.hidden = !needs;
  }
  function initMore(panel) {
    if (panel._esgMoreBtn) return;
    if (!panel.id) panel.id = 'esg-desc-' + Math.random().toString(36).slice(2, 8);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'esg-more__btn no-hover';
    btn.setAttribute('aria-controls', panel.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.hidden = true;
    btn.innerHTML = '<span>' + esc(moreLabel(false)) + '</span>' +
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="16" height="16"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    panel.insertAdjacentElement('afterend', btn);
    panel._esgMoreBtn = btn;
    panel.classList.add('esg-more');
    panel.setAttribute('data-esg-more', 'closed');
    btn.addEventListener('click', function () {
      var open = panel.getAttribute('data-esg-more') !== 'open';
      setMore(panel, open);
      // Folding a long text can leave the reader far below it; bring the start of the text back into view.
      if (!open) {
        var pad = parseFloat(getComputedStyle(docEl).scrollPaddingTop) || 0;
        if (panel.getBoundingClientRect().top < pad) panel.scrollIntoView({ block: 'start', behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
    });
    // Tabbing to a link in the hidden part opens the text, so the focused link can be seen.
    panel.addEventListener('focusin', function (e) {
      if (!panel.classList.contains('is-clamped')) return;
      if (e.target.getBoundingClientRect().bottom > panel.getBoundingClientRect().bottom - 8) setMore(panel, true);
    });
    // Pictures in the description change its height once they load.
    panel.addEventListener('load', function () { measureMore(panel); }, true);
    measureMore(panel);
  }
  function initMores() { $all(MORE_SEL).forEach(initMore); }
  function remeasureMores() { $all('.esg-more').forEach(measureMore); }

  /* ---------- header shadow on scroll ---------- */
  function initHeader() {
    var header = $('[data-esg-header]');
    if (!header || header.hasAttribute('data-esg-ready')) return;
    header.setAttribute('data-esg-ready', '1');
    var wrap = header.closest('.shopify-section') || header;
    var ann = $('.esg-announce', header);
    // Let the announcement scroll away while the header row + search stay pinned.
    var setTop = function () { wrap.style.top = ann ? (-ann.offsetHeight) + 'px' : '0px'; };
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', debounce(setTop, 100));
    setTop();
    onScroll();
  }

  /* ---------- boot ---------- */
  function boot() {
    $all('[data-esg-search]').forEach(initSearch);
    $all('[data-esg-bab]').forEach(initBuildABox);
    initHeader();
    watchSideCart();
    initBundles();
    decorateSizes();
    initMores();
    if (boot.done) return; // theme editor section reloads: the timers and observer below already run
    boot.done = true;
    window.addEventListener('resize', debounce(remeasureMores, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasureMores);
    // Theme builds its size buttons after load; retry a few times, then watch for quick-view popups.
    var tries = 0;
    var t = setInterval(function () { decorateSizes(); if (++tries > 12) clearInterval(t); }, 250);
    if ('MutationObserver' in window) {
      new MutationObserver(debounce(function () { decorateSizes(); initBundles(); initMores(); }, 150))
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
  window.ESGCart = { add: addItems, afterAdd: afterAdd };
})();
